const forInsurersResources = {
    title: 'For Insurers',
};
export default forInsurersResources;